import type { FC } from 'react';
import React, { useEffect, useRef, useState } from 'react';

import type { TTimer } from './models';

export const Timer: FC<TTimer> = ({
    breakPoint = '00:00:00',
    calculateSeconds,
    onStart = () => {},
    onStop = () => {},
    secondsToTime,
}) => {
    const [seconds, setSeconds] = useState<string | undefined>(undefined);
    const prevSeconds = useRef<string | undefined>(undefined);
    const breakPointDate = useRef<Date | null>(null);
    const interval = useRef<number | null>(null);

    const updateState = () => {
        if (breakPointDate.current) {
            const secs = calculateSeconds(breakPointDate.current);

            setSeconds(String(secs));
        }
    };

    useEffect(() => {
        breakPointDate.current = new Date();

        const [hours, minutes, secs] = breakPoint
            .split(':')
            .map(digitAsStr => parseInt(digitAsStr, 10) || 0);

        breakPointDate.current.setHours(hours, minutes, secs);
        updateState();

        interval.current = window.setInterval(updateState, 1000);

        return () => {
            if (interval.current) {
                clearInterval(interval.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!prevSeconds.current && Number(seconds) > 0) {
            onStart();
        }

        if (
            (!prevSeconds.current || (prevSeconds.current && Number(prevSeconds.current) > 0)) &&
            Number(seconds) === 0
        ) {
            onStop();

            if (interval.current) {
                clearInterval(interval.current);
            }
        }
    });

    useEffect(() => {
        prevSeconds.current = seconds;
    }, [seconds]);

    return <>{secondsToTime(seconds)}</>;
};
